import { gql } from '@apollo/client';
import { Questionnaire } from '../Common';

export const getQuestionnaire = gql`
  query {
    dans_fund_questionnaire {
      id
      name
      questions
    }
  }
`;

export interface GetQuestionnaireResponse {
  dans_fund_questionnaire: Questionnaire[];
}
